// extracted by mini-css-extract-plugin
export var col = "style-module--col--c79ce";
export var footer = "style-module--footer--cc446";